import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import OffCanvas from 'components/molecules/OffCanvas';
import { getTodayDayOfMonth } from 'helper/date';
import appConfig from 'helper/mapBackendConfig';
import { getUserData } from 'store/profile';
import { actionCreators, getCurrentViewID, getIsOffCanvasOpen, getOffCanvasNavLinks } from 'store/view';

const mapStateToProps = (state) => {
	const internalPropsMap = {
		activeViewId: getCurrentViewID(state),
		isOpen: getIsOffCanvasOpen(state),
		links: getOffCanvasNavLinks(state),
		userData: getUserData(state),
		todayDayOfMonth: getTodayDayOfMonth(),
		oneTrustEnabled: appConfig.env.oneTrustEnabled
	};

	const linksSignatureList = internalPropsMap.links.map((link, index) => {
		return `${index}/${link.additions ? link.additions.length : 0}/${link.selected}/${link.href}`;
	});

	return {
		...internalPropsMap,
		linksSignature: `${internalPropsMap.links.length}-${linksSignatureList.join('-')}`,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OffCanvas as any) as any;
